if (!customElements.get('announcement-bar')) {
  customElements.define(
    'announcement-bar',
    class SiteDrawer extends window.BAO.CustomElement {
      constructor () {
        super()

        if (this.els.message === undefined) return

        setInterval(() => {
          this.moveAnimationClass()
        }, Number(window.theme.announcementBarInterval))
      }

      moveAnimationClass () {
        const className = 'ann-Bar_Message-Animation'
        const elementsArray = [...this.els.message.elements]

        const currentAnimationIndex = elementsArray.findIndex(el =>
          el.className.includes(className)
        )

        if (elementsArray.length - 1 === currentAnimationIndex) {
          elementsArray[currentAnimationIndex].classList.remove(className)
          elementsArray[0].classList.add(className)
        } else {
          elementsArray[currentAnimationIndex].classList.remove(className)
          elementsArray[currentAnimationIndex + 1].classList.add(className)
        }
      }
    }
  )
}
